import { render, staticRenderFns } from "./SkillcourtRotterdamLayout.vue?vue&type=template&id=ae8b9ce8&"
import script from "./SkillcourtRotterdamLayout.vue?vue&type=script&lang=js&"
export * from "./SkillcourtRotterdamLayout.vue?vue&type=script&lang=js&"
import style0 from "./SkillcourtRotterdamLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports